<template>
    <div class="webIntroduce">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div class="contentLeft">
                        <ul>
                            <li v-for="(item, index) in menuList" :key="index" :class="active == index ? 'active' : ''" @click="activeChange(item, index)">
                                <img src="../../assets/img/index/arrows4.png" alt="" v-if="active == index">
                                <div style="width: 12px;" v-else></div>
                                <span style="margin-left: 10px;">{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="contentRight">
                        <div v-if="active == 0">
                            <div class="top">
                                <img class="titleBackground" src="../../assets/img/index/titleBackground.png" alt="">
                                <div class="title3">
                                    <img src="../../assets/img/index/creditHundred.png" alt="" style="width: 34px;">
                                    <span style="margin-left: 10px;white-space: nowrap;">{{activeName}}</span>
                                </div>
                            </div>
                            <div class="bottom" v-html="info.introduce"></div>
                        </div>
                        <div v-if="active == 1">
                            <div class="top">
                                <img class="titleBackground" src="../../assets/img/index/titleBackground.png" alt="">
                                <div class="title3">
                                    <img src="../../assets/img/index/creditHundred.png" alt="" style="width: 34px;">
                                    <span style="margin-left: 10px;white-space: nowrap;">{{activeName}}</span>
                                </div>
                            </div>
                            <div class="bottom" v-html="info.copyright"></div>
                        </div>
                        <div v-if="active == 2">
                            <div class="top">
                                <img class="titleBackground" src="../../assets/img/index/titleBackground.png" alt="">
                                <div class="title3">
                                    <img src="../../assets/img/index/creditHundred.png" alt="" style="width: 34px;">
                                    <span style="margin-left: 10px;white-space: nowrap;">{{activeName}}</span>
                                </div>
                            </div>
                            <div class="bottom" v-html="info.advertisement"></div>
                        </div>
                        <div v-if="active == 3">
                            <div class="top">
                                <img class="titleBackground" src="../../assets/img/index/titleBackground.png" alt="">
                                <div class="title3">
                                    <img src="../../assets/img/index/creditHundred.png" alt="" style="width: 34px;">
                                    <span style="margin-left: 10px;white-space: nowrap;">{{activeName}}</span>
                                </div>
                            </div>
                            <div class="bottom" v-html="info.recruitment"></div>
                        </div>
                        <div v-if="active == 4">
                            <div class="top">
                                <img class="titleBackground" src="../../assets/img/index/titleBackground.png" alt="">
                                <div class="title3">
                                    <img src="../../assets/img/index/creditHundred.png" alt="" style="width: 34px;">
                                    <span style="margin-left: 10px;white-space: nowrap;">{{activeName}}</span>
                                </div>
                            </div>
                            <div class="bottom contact-info">
                                <div>地址：{{ info.address }}</div>
                                <div>邮编：{{ info.zipcode }}</div>
                                <div>电话：{{ info.phone }}</div>
                                <div>传真：{{ info.fax }}</div>
                                <div>电子信箱：{{ info.email }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
export default {
    name: 'webIntroduce',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            menuList: [
                {
                    name: '网站介绍',
                },
                {
                    name: '版权申明',
                },
                {
                    name: '广告服务',
                },
                {
                    name: '人才招聘',
                },
                {
                    name: '联系我们',
                },
            ],
            active: 0,
            activeName: '网站介绍',
            info: {}
        }
    },
    watch: {
      // 监听路由参数的变化
      '$route.query.documentTitle': {
        immediate: true,
        handler(newVal, oldVal) {
          // 当路由参数变化时，这里会被调用
          // 你可以在这里根据新的参数执行你的逻辑
        //   console.log('参数变化了:', newVal);
            this.documentTitle = newVal
            document.title = newVal
            this.applyRouteQuery()

            this.getIndexInfo()
        }
      }
    },
    created() {
        window.scrollTo(0 ,0)
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.documentTitle || '网站介绍'
        this.applyRouteQuery()
    },
    mounted() {
    },
    methods: {
        getIndexInfo() {
            let _this = this
            api.getIndexInfo().then(res => {
                let { data } = res
                if (data.status == 200) {
                    _this.info = data.data.websiteInfo
                    console.log(_this.info);
                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },
        applyRouteQuery() {
            const active = Number(this.$route.query.active || 0)
            const item = this.menuList[active] || this.menuList[0]
            this.activeChange(item, active)
        },
        // 切换菜单
        activeChange(item, index) {
            this.active = Number(index)
            this.documentTitle = item.name
            this.activeName = item.name
        }
    }
}
</script>

<style lang="less" scoped>
.webIntroduce {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 600px;
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                .contentLeft {
                    width: 26%;
                    height: 230px;
                    li {
                        display: flex;
                        justify-content: left;
                        align-items: center;
                        padding: 0 15px;
                        height: 46px;
                        line-height: 46px;
                        font-size: 20px;
                        color: #666;
                        cursor: pointer;
                        border: 1px solid #D9D9D9;
                        img {
                            display: inline-block;
                        }
                    }
                    li:nth-of-type(n+2) {
                        border-top-color: #fff;
                    }
                    .active {
                        color: #1A68E8;
                        border: 1px solid #1A68E8;
                        border-top-color: #1A68E8 !important;
                    }
                }
                .contentRight {
                    width: 73%;
                    border: 1px solid #D9D9D9;
                    padding: 10px 30px;
                    .top {
                        height: 55px;
                        position: relative;
                        .titleBackground {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                        .title3 {
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            left: 15px;
                            display: flex;
                            align-items: center;
                            font-size: 26px;
                            font-weight: 700;
                            background: linear-gradient(to bottom, #005CF3, #134BA8);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }
                        .more {
                            position: absolute;
                            right: 15px;
                            top: 50%;
                            transform: translateY(-50%);
                            font-size: 18px;
                            color: #1A68E8;
                            cursor: pointer;
                        }
                    }
                    .bottom {
                        padding: 20px 0;
                    }
                }
            }
        }
    }
}
</style>
